/** Calendrier par défaut : 1er sept. → 31 août à partir du libellé 2025-2026. */
export function datesFromSchoolYearLabel(label: string): {
  start_date: string;
  end_date: string;
} | null {
  const s = label.trim().replace(/\//g, '-');
  const m = s.match(/^(\d{4})-(\d{4})$/);
  if (!m || parseInt(m[2], 10) !== parseInt(m[1], 10) + 1) return null;
  return {
    start_date: `${m[1]}-09-01`,
    end_date: `${m[2]}-08-31`,
  };
}

export function suggestNextSchoolYearLabel(currentLabel?: string): string {
  if (!currentLabel) {
    const y = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    const startYear = month >= 9 ? y : y - 1;
    return `${startYear}-${startYear + 1}`;
  }
  const m = currentLabel.match(/^(\d{4})-(\d{4})$/);
  if (!m) return '';
  const nextStart = parseInt(m[2], 10);
  return `${nextStart}-${nextStart + 1}`;
}
